const ACTION_PAST_TENSE = new Map<string, string>([
  ['approve', 'approved'],
  ['reject', 'rejected'],
  ['draft', 'drafted'],
  ['re-draft', 're-drafted'],
])

export function toPastTenseAction(actionLabel: string): string {
  const normalized = actionLabel.trim().toLowerCase()
  return ACTION_PAST_TENSE.get(normalized) ?? `${normalized}d`
}
